const DEFAULT_TEST_API_URL = 'https://localhost:3000/';

const envConfig = (() => {
  const obj = {
    urls: {
      api: '',
    },
    keys: {
      googleCaptcha: '',
    },
  };

  const { NX_PUBLIC_API_URL, NX_PUBLIC_TEST_MODE, NX_PUBLIC_GOOGLE_RECAPTCHA_KEY } = process.env;

  obj.urls.api = NX_PUBLIC_TEST_MODE === 'true' ? `${DEFAULT_TEST_API_URL}` : `${NX_PUBLIC_API_URL}`;
  obj.keys.googleCaptcha = NX_PUBLIC_GOOGLE_RECAPTCHA_KEY ?? '';

  return obj;
})();

export const config = {
  ...envConfig,
  version: '1.0.0',
};
